"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdManagerYandex = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var core_1 = require("@dp-instant/core");
var social_1 = require("@dp-instant/social");
var utils_1 = require("@dp-instant/utils");
var interfaces_1 = require("@dp-instant/interfaces");
var track = function (name, v, p) { var _a; return (_a = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker)) === null || _a === void 0 ? void 0 : _a.track("admanager_" + name, v, p); };
var AdManagerYandex = (function (_super) {
    tslib_1.__extends(AdManagerYandex, _super);
    function AdManagerYandex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdManagerYandex.prototype.init = function (yasdk) {
        this.yasdk = yasdk;
    };
    AdManagerYandex.prototype.showAd = function (id, force, preloadNext) {
        if (force === void 0) { force = false; }
        if (preloadNext === void 0) { preloadNext = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status, yasdk_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = interfaces_1.AdResponse.NOT_SUPPORTED;
                        if (!this.yasdk) return [3, 2];
                        if (!force) {
                            if (social_1.AdManagerBase.needToThrottleAd(social_1.AdManagerBase.config.throttling.interstitial)) {
                                return [2, interfaces_1.AdResponse.THROTTLED];
                            }
                        }
                        yasdk_1 = this.yasdk;
                        status = interfaces_1.AdResponse.UNKNOWN;
                        this.onAdStarted({ placement: id, status: status });
                        return [4, new Promise(function (resolve) {
                                yasdk_1.adv.showFullscreenAdv({
                                    callbacks: {
                                        onClose: function (wasShown) {
                                            return resolve(wasShown ? interfaces_1.AdResponse.PLAYED : interfaces_1.AdResponse.CANCELLED);
                                        },
                                        onError: function (error) {
                                            utils_1.log.warn(error);
                                            resolve(interfaces_1.AdResponse.FAILED);
                                        },
                                        onOffline: function () { return resolve(interfaces_1.AdResponse.FAILED); }
                                    }
                                });
                            })];
                    case 1:
                        status = _a.sent();
                        this.onAdEnded({ placement: id, status: status });
                        if (status === interfaces_1.AdResponse.PLAYED) {
                            track("show_inter", 1, { id: id });
                            social_1.AdManagerBase.config.throttling.interstitial.lastShow = Date.now();
                        }
                        _a.label = 2;
                    case 2: return [2, status];
                }
            });
        });
    };
    AdManagerYandex.prototype.showRewardAd = function (id, preloadNext) {
        if (preloadNext === void 0) { preloadNext = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status, yasdk_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = interfaces_1.AdResponse.NOT_SUPPORTED;
                        if (!this.yasdk) return [3, 2];
                        yasdk_2 = this.yasdk;
                        status = interfaces_1.AdResponse.UNKNOWN;
                        this.onAdStarted({ placement: id, status: status });
                        return [4, new Promise(function (resolve) {
                                var rewarded = false;
                                yasdk_2.adv.showRewardedVideo({
                                    callbacks: {
                                        onOpen: function () { return (rewarded = false); },
                                        onClose: function () {
                                            resolve(rewarded ? interfaces_1.AdResponse.PLAYED : interfaces_1.AdResponse.CANCELLED);
                                        },
                                        onError: function (error) {
                                            utils_1.log.warn(error);
                                            rewarded = false;
                                            resolve(interfaces_1.AdResponse.FAILED);
                                        },
                                        onRewarded: function () { return (rewarded = true); },
                                        onOffline: function () { return resolve(interfaces_1.AdResponse.FAILED); }
                                    }
                                });
                            })];
                    case 1:
                        status = _a.sent();
                        this.onAdEnded({ placement: id, status: status });
                        if (status === interfaces_1.AdResponse.PLAYED) {
                            track("show_reward", 1, { id: id });
                        }
                        _a.label = 2;
                    case 2: return [2, status];
                }
            });
        });
    };
    AdManagerYandex = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], AdManagerYandex);
    return AdManagerYandex;
}(social_1.AdManagerBase));
exports.AdManagerYandex = AdManagerYandex;
//# sourceMappingURL=AdManagerYandex.js.map